import React, { useState, useEffect } from "react";
import { useAuth } from "../../components/Auth/AuthProvider";
import { useTheme } from "../../App";
import styles from "./Onboarding.module.css";
import diffusionIconLight from "../../assets/diffusion_light.svg";
import diffusionIconDark from "../../assets/diffusion_dark.svg";

const Onboarding: React.FC = () => {
  const { user, updateUserProfile } = useAuth();
  const { theme, setTheme } = useTheme();
  const getActualTheme = (): "light" | "dark" => {
    if (theme === "system") {
      return window.matchMedia("(prefers-color-scheme: dark)").matches
        ? "dark"
        : "light";
    }
    return theme as "light" | "dark";
  };
  const actualTheme = getActualTheme();
  const [fullName, setFullName] = useState("");
  const [loading, setLoading] = useState(false);

  const diffusionIcon =
    actualTheme === "dark" ? diffusionIconDark : diffusionIconLight;

  useEffect(() => {
    if (user?.displayName) {
      setFullName(user.displayName);
    }
  }, [user]);

  const isValidName = fullName.trim().length >= 2;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!isValidName || loading) return;

    setLoading(true);

    try {
      await updateUserProfile({
        fullName: fullName.trim(),
        displayName: fullName.trim(),
      });

      window.history.pushState({}, "", "/onboarding/use-case");
      window.dispatchEvent(new PopStateEvent("popstate"));
    } catch (error) {
      // console.error("Error saving name:", error);
      setLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <button
          className={styles.logoButton}
          onClick={() => (window.location.href = "/")}
          aria-label="Go to home"
        >
          <img src={diffusionIcon} alt="Noah" className={styles.logo} />
        </button>
      </div>

      <div className={styles.scrollableContent}>
        <div className={styles.content}>
          <h1 className={styles.title}>What's your name?</h1>
          <p className={styles.description}>
            This is what others see when you join files, send invites, and more.
          </p>

          <form onSubmit={handleSubmit} className={styles.form}>
            <input
              type="text"
              placeholder="Enter your full name"
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
              className={styles.input}
              autoFocus
              disabled={loading}
            />

            <div className={styles.buttonContainer}>
              <button
                type="submit"
                disabled={!isValidName || loading}
                className={styles.submitButton}
              >
                Continue
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Onboarding;
